// 在此文件定义枚举，然后通过export.default导出，代码生成时可以进行选择，选择后代码生成引擎会自动应用该枚举对字段进行解析

// const <枚举名称> = {
//   <枚举项>: {
//     label: <label>,
//     value: <value>
//   }
// }

import * as BmEnums from '@/utils/bm-enums'
import * as ScEnums from '@/utils/sc-enums'
import * as InvoiceEnums from '@/utils/invoice-enums'



/**
 * 作废状态
 */
const CANCELLATION_STATUS = {
  NOT_CANCELLED: {
    label: '未作废',
    value: 0
  },
  CANCELLED: {
    label: '已作废',
    value: 1
  }
}

/**
 * 客户类型
 */
const CUSTOMER_TYPE = {
  CUSTOMER: {
    label: '客户',
    value: 0,
    alias: 'kehu'
  },
  SUPPLIER: {
    label: '供应商',
    value: 1,
    alias: 'supplier'
  },
  OUR_COMPANY: {
    label: '本方公司',
    value: 2,
    alias: 'ourCompany'
  }
}

const CONTRACT_TYPE = {
  YEAR: {
    label: '年度',
    value: 0,
  },
  HALF_YEAR: {
    label: '半年度',
    value: 1,
  },
  QUARTER: {
    label: '季度',
    value: 2,
  },
  MONTH: {
    label: '月度',
    value: 3,
  },
  BATCH: {
    label: '批次',
    value: 4,
  },
  TEMPORARY: {
    label: '临时',
    value: 5,
  }
}

const CONTRACT_BUSINESS_TYPE = {
  CUSTOMER: {
    label: '客户合同',
    value: 0
  },
  SHIP: {
    label: '船舶合同',
    value: 1
  },
  PORT: {
    label: '码头合同',
    value: 2
  }
}

const SHIP_TYPE = {
  BARGE: {
    label: '驳船',
    value: 0
  },
  RIVER: {
    label: '江船',
    value: 1
  },
  SEA: {
    label: '海船',
    value: 2
  }
}

/** 船舶构造/用途 */
const SHIP_STRUCTRUE_TYPE = {
  BULK_CARGO: {
    label: '散货船',
    value: 0
  },
  CONTAINER_SHIP: {
    label: '集装箱船',
    value: 1
  }
}

/** 船舶性质 */
const SHIP_NATURE = {
  ZY: {
    label: '自有',
    value: '0'
  },
  SC: {
    label: '市场',
    value: '1'
  }
}

/** 船舶业务类型 */
const SHIP_OWNER_SHIP = {
  BM: {
    label: '宝镁过驳业务',
    value: 1
  },
  OTHER: {
    label: '其他',
    value: 0
  }
}

/** 船舶航行状态 */
const SHIP_STATUS = {
  FLIGHT: {
    label: '在航',
    value: 0,
  },
  MAINTENANCE: {
    label: '维修',
    value: 1,
  },
  IDLE: {
    label: '闲置',
    value: 2,
  }
}
/** 船舶协议类型 */
const SHIP_PROTOCOL_TYPE = {
  // 自有、加盟、协议、未签
  ZY: {
    label: '自有',
    value: 1
  },
  SC: {
    label: '加盟',
    value: 2
  },
  PROTOCOL: {
    label: '协议',
    value: 3
  },
  // // 长协
  // LONG_TERM: {
  //   label: '长协',
  //   value: 1
  // },
  // // 年度
  // YEARLY: {
  //   label: '年度',
  //   value: 2
  // },
  // // 半年
  // HALF_YEAR: {
  //   label: '半年',
  //   value: 3
  // },
  // // 季度
  // QUARTERLY: {
  //   label: '季度',
  //   value: 4
  // },
  // // 月度
  // MONTHLY: {
  //   label: '月度',
  //   value: 5
  // },
  // 未签
  NOT_SIGNED: {
    label: '未签',
    value: 0
  }
};


/** 船舶证件类型 */
const SHIP_ATTACHMENT_ATTR1 = {
  SHIP: {
    label: '船舶',
    value: 0,
    require: true
  },
  OWNER_IDCARD: {
    label: '船东身份证',
    value: 1,
    require: false
  }
}


/** 船舶奖惩账单类型 */
const SHIP_REWARD_BILL_TYPE = {
  BM_Bill: {
    label: '过驳账单',
    value: 1
  },
  MARK_BILL: {
    label: '市场业务账单',
    value: 2
  }
}

/**
 * 通用类-是否
 */
const YES_OR_NO = {
  YES: {
    label: '是',
    value: 1
  },
  NO: {
    label: '否',
    value: 0
  },
}


/**
 * 附件业务类型
 */
const ATTACHMENT_BUSINESS_TYPE = {
  CONTRACT: {
    label: '合同',
    value: 10
  },
  BM_SHIP_BILL: {
    label: '宝镁船舶账单',
    value: 20
  },
  BM_PORT_BILL: {
    label: '宝镁港口账单',
    value: 30
  },
  SC_PLAN_ATTACHMENT: {
    label: '市场计划附件',
    value: 40
  },
  PAYMENT_SETTLEMENT: {
    label: '费用结算',
    value: 50
  },
  SHIP: {
    label: '船舶',
    value: 60
  },
  SHIP_REWARDS: {
    label: '船舶奖惩',
    value: 70
  },
  BM_VOYAGE: {
    label: '宝镁航次',
    value: 80
  },
  CONTRACT_ELECTRONIC_FILE: {
    label: '合同-电子合同',
    value: 90
  }
}
/** 付款类型 */
const PAYMENT_APPLICATION_TYPE = {
  SUPPLIER_PAYMENT: {
    label: '供应商付款',
    value: 10
  },
  SHIPOWNER_PAYMENT: {
    label: '宝镁船东付款',
    value: 20
  },
  PORT_PAYMENT: {
    label: '港口费用',
    value: 30
  }
}

/**
 * 操作日志
 */
const OPER_LOG_TYPE = {
  BM_DISPATCH: {
    label: '宝镁调度',
    value: 10,
  },
  BM_SHIP_BILL:{
    label: '宝镁船舶账单',
    value: 20,
  },
  BM_PORT_BILL:{
    label: '宝镁港口账单',
    value: 30,
  },
  BM_VOYAGE: {
    label: '宝镁航次',
    value: 40
  }
}

/**
 * 审批状态
 */
const APPROVAL_STATUS = {
  PENDING: {
    label: '待提交',
    value: 0
  },
  APPROVING: {
    label: '审批中',
    value: 1
  },
  APPROVED: {
    label: '审批通过',
    value: 2
  },
  REJECTED: {
    label: '审批拒绝',
    value: 3
  }
}

/**
 * 绑定状态
 */
const BIND_STATUS = {
  PENDING: {
    label: '待绑定',
    value: 0
  },
  BINDED: {
    label: '已绑定',
    value: 1
  },
}
/*
 * 税率
 */
const TAX_RATE = {
  TAX_RATE_13: {
    label: '13%',
    value: 13
  },
  TAX_RATE_9: {
    label: '9%',
    value: 9
  },
  TAX_RATE_6: {
    label: '6%',
    value: 6
  },
  TAX_RATE_3: {
    label: '3%',
    value: 3
  },
  TAX_RATE_1: {
    label: '1%',
    value: 1
  },
  TAX_RATE_0: {
    label: '0%',
    value: 0
  }
}

/**
 * 结算方式
*/
const SETTLEMENT_METHOD = {
  MONTHLY: {
    label: '月结',
    value: 1
  },
  PER_INVOICE: {
    label: '票结',
    value: 2
  },
}
/*
* 账单审批状态
*/
const BILL_SP_STATUS = {
  PENDING: {
    label: '待提交',
    value: 0
  },
  APPROVING: {
    label: '审批中',
    value: 1
  },
  APPROVED: {
    label: '审批通过',
    value: 2
  },
  REJECTED: {
    label: '审核驳回',
    value: 3
  }
}
/*
* 签约状态
*/
const BILL_SIGN_STATUS = {
  PENDING: {
    label: '待发起',
    value: 0
  },
  APPROVING: {
    label: '签约中',
    value: 1
  },
  APPROVED: {
    label: '已签约',
    value: 2
  },
  REJECTED: {
    label: '有异议',
    value: 3
  }
}
/*
* 付款状态
*/
const PAYMENT_STATUS = {
  UNPAID: {
    label: '待付款',
    value: 1
  },

  PAYMENT_COMPLETED: {
    label: '已付款',
    value: 2
  }
}

/*
* 账单类型
*/
const BILL_TYPE = {
  BM_SHIP_BILL: {
    label: '宝镁船舶账单',
    value: 1
  },
  BM_PORT_BILL: {
    label: '宝镁港口账单',
    value: 2
  },
  MARKET_BILL: {
    label: '市场账单',
    value: 3
  }
}

/*
* 合同状态
*/
const CONTRACT_STATUS = {
  TO_BE_ARCHIVED: {
    label: '待归档',
    value: 0,
    tagType: 'primary'
  },
  ARCHIVED: {
    label: '已归档',
    value: 1,
    tagType: 'success'
  }
}

/*
* 航道调度计划类型
*/
const WATERWAY_SCHEDULE_PLAN_TYPES = {
  ENTER: {
    label: '进',
    value: 0,
    color: '#1F61FF',
    bgColor: '#D0E3FF'
  },
  OUT: {
    label: '出',
    value: 1,
    color: '#299A0C',
    bgColor: '#E4FBE5'
  },
  CLOSE: {
    label: '封',
    value: 2,
    color: '#bf2a13',
    bgColor: '#FFF0F5'
  }
}

/**
 * 加油记录状态
 */
const FUEL_RECORD_STATUS = {
  UNVERIFIED: {
    label: '待核销',
    value: 0
  },
  VERIFYING: {
    label: '核销中',
    value: 1
  },
  VERIFIED: {
    label: '已核销',
    value: 2
  },
  PARTIAL_VERIFY: {
    label: '部分核销',
    value: 3
  }
}
/**
 * 干湿吨
 */
const DRY_WET_TON_FLAG = {
  UNVERIFIED: {
    label: '干吨',
    value: 0
  },
  VERIFYING: {
    label: '湿吨',
    value: 1
  }
}

/**
 * 船舶运价结算类型
 */
const SHIP_FREIGHT_SETTLEMENT_TYPE = {
  /**
   * 阶梯运价
   */
  STAIRCASE: {
    label: '阶梯运价',
    value: 0
  },
  /**
   * 固定单价
   */
  FIXED_PRICE: {
    label: '固定单价',
    value: 1
  },
}

export default {
  // <枚举名称>
  CANCELLATION_STATUS,
  CUSTOMER_TYPE,
  YES_OR_NO,
  OPER_LOG_TYPE,
  ATTACHMENT_BUSINESS_TYPE,
  CONTRACT_TYPE,
  CONTRACT_BUSINESS_TYPE,
  ...BmEnums,
  ...ScEnums,
  ...InvoiceEnums,
  APPROVAL_STATUS,
  BIND_STATUS,
  TAX_RATE,
  SETTLEMENT_METHOD,
  BILL_SP_STATUS,
  PAYMENT_STATUS,
  BILL_SIGN_STATUS,
  SHIP_TYPE,
  SHIP_STRUCTRUE_TYPE,
  SHIP_NATURE,
  SHIP_OWNER_SHIP,
  SHIP_STATUS,
  SHIP_ATTACHMENT_ATTR1,
  SHIP_REWARD_BILL_TYPE,
  BILL_TYPE,
  CONTRACT_STATUS,
  WATERWAY_SCHEDULE_PLAN_TYPES,
  FUEL_RECORD_STATUS,
  PAYMENT_APPLICATION_TYPE,
  DRY_WET_TON_FLAG,
  SHIP_PROTOCOL_TYPE,
  SHIP_FREIGHT_SETTLEMENT_TYPE,
}
